import { CarouselComponent } from "../../../../CarouselComponent";
import PainelCovidImg from "../../../../../assets/images/painel_covid.svg";
import PainelPesquisaImg from "../../../../../assets/images/painel_pesquisa.svg";
import { Slide } from "./Slide";

import * as S from "./styles";

export function PanelCaroussel() {
  return (
    <CarouselComponent>
      <S.Content>
        <Slide img={PainelCovidImg} imgAlt="painel de covid-19" index={1} />
      </S.Content>
      <S.Content>
        <Slide img={PainelPesquisaImg} imgAlt="painel de covid-19" index={2} />
      </S.Content>
    </CarouselComponent>
  );
}
